import ManageCommentDrawer from './ManageCommentDrawer'

export default ManageCommentDrawer
